/***
*
*   KEBAB MENU
*   A ⋮ trigger that reveals an action list. Each item is { label, action, color? }.
*   Manages its own open state and closes on outside click or after any action.
*
**********/

import { useState, useEffect, useRef } from 'react';
import Style from './kebab-menu.tailwind.js';

export function KebabMenu({ items = [] }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    function handler(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, [open]);

  return (
    <div ref={ref} className={Style.wrapper}>
      <button
        onClick={e => { e.stopPropagation(); setOpen(o => !o); }}
        className={Style.trigger}
      >
        &#8942;
      </button>

      {open && (
        <div onClick={e => e.stopPropagation()} className={Style.dropdown}>
          {items.map((item, i) => (
            <button
              key={i}
              onClick={() => { item.action(); setOpen(false); }}
              className={Style.item}
              style={item.color ? { color: item.color } : undefined}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
